import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap'
import { useLocation } from "react-router-dom";

export default function PaymentSuccess() {
	let query = new URLSearchParams(useLocation().search);

	const [summary, setSummary] = useState([]);
	const [isGetSummary, setIsGetSummary] = useState(false);
	//const [isSentMail, setIsSentMail] = useState(false);
	const [modalShow, setModalShow] = useState(false);

	useEffect(() => {
		if (isGetSummary === false) {
			axios.get('/api/order/' + query.get("paymentID"))
				.then(res => {
					var trans = res.data[0]['trans'];
					setSummary({
						Owner_name: trans.Owner_name,
						Owner_NRICPassport: trans.Owner_NRICPassport,
						Owner_contactno: trans.Owner_contactno,
						Owner_email: trans.Owner_email,
						SumInsured: trans.SumInsured,
						premium: trans.premium,
						servicetax: trans.servicetax,
						stamp_duty: trans.stamp_duty,
						total_premium: trans.total_premium,
						period_from: trans.period_from,
						period_to: trans.period_to,
						bike_model: trans.bike_model,
						bike_YearofManu: trans.bike_YearofManu,
						bike_neworused: trans.bike_neworused,
						bike_serialno: trans.bike_serialno,
						beneficiary_name: trans.beneficiary_name,
						beneficiary_NRIC: trans.beneficiary_NRIC,
						beneficiary_relationship: trans.beneficiary_relationship,
						insurer: trans.insurer,
						plan_name: trans.plan_name,
						TransactionNo: trans.TransactionNo,
						payment_status: trans.payment_status,
						txn_message: trans.txn_message
					});
					setIsGetSummary(true);
				})
		}
	}, [query]);

/* 	useEffect(() => {
		if (isGetSummary === true && summary.length !== 0 && isSentMail === false) {
			axios({
				method: 'post',
				url: '/api/sendsuccessfulCasemail',
				"headers": {
					"content-type": "application/json",
				},
				data: {
					setSuccessCases: summary
				}
			})
				.then(function (response) {
					console.log("send email");
					setIsSentMail(true);
				})
				.catch(function (error) {
					console.log(error);
				})
		}
	}, [summary]); */

	return (
		<div id="product-hero">
			{isGetSummary ?
				<section id="body">
					<PromptMessage show={modalShow} onHide={() => setModalShow(false)} />
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="row shadow title position-relative">
									<h2 className="text-center m-5 text-white fw-bold">Payment Successful</h2>
								</div>
								<div className="row content">
									<div className="col-1"></div>
									<div className="col-10 shadow bg-white rounded">
										<p className="mt-4">Hi, {summary.Owner_name}</p>
										<p>Thank you for your payment. Your transaction has been successful subject to Anti Money Laundering Act and Sanction screening.</p>
										<p>The insurance coverage will only take effect upon approval from Allianz General Insurance Company (Malaysia) Berhad (Allianz).</p>
										<p>Confirmation of coverage will be issued by Allianz to your email address after the approval process</p>
										<p>Full premiums will be refunded by Howden if your application is not approved by Allianz.</p>
										<p>For any inquiries, please email us at <a href="mailto:instaPol@howdengroup.com" target="_blank">instaPol@howdengroup.com</a></p>

										<div className="card-deck mb-3 text-center">
											<div className="card mb-4 box-shadow">
												<div className="card-header" style={{ backgroundColor: "#c7ddea" }}>
													<h4 className="my-0" style={{ backgroundColor: "#c7ddea" }}>Purchase Summary</h4>
												</div>
												<div className="card-body p-0">
													<table className="table table-bordered table-condensed mb-0">
														<tbody>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Insurance Company <br /></td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{summary.insurer}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Transaction Reference No</td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{summary.TransactionNo}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Bicycle Sum Insured</td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>RM {summary.SumInsured.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
															</tr>															
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Total Annual Premium</td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{"RM " + summary.total_premium.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="col-12">
												<a href="/Landing" className="btn btn-primary mt-4" role="button">Back to Home</a>
											</div>
										</div>
										<div className="row mt-4">
											<label className="col-12 col-form-label text-center">You might also be interested in</label>
										</div>
										<div id="othProducts" className="row text-center justify-content-around mb-3">
											<div className="col-sm-3 mt-3">
												<a href="https://instapol.my/travel">
													<img  src="../images/travel.png" loading="lazy" />
												</a>
											</div>
											<div className="col-sm-3 mt-3">
												<a href="https://instapol.my/motor">
													<img  src="../images/motor.png" loading="lazy" />
												</a>
											</div>
											<div className="col-sm-3 mt-3">
												<a href="https://howden-wmotor.instapol.my/landing">
													<img  src="../images/extended-motor.png" loading="lazy" />
												</a>
											</div>
										</div>
									</div>
									<div className="col-1"></div>
								</div>
							</div>
						</div>
					</div>
				</section>
				:
				<div className="text-center mt-5">
					<img src="../images/loading.gif" />
					<br />
					Please wait
				</div>
			}
		</div>
	);
}

function PromptMessage(props) {
	return (
		<Modal {...props}
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header>
				<Modal.Title className="container-fluid">
					<div className="row">
						<button type="button" className="close" onClick={props.onHide}><i className="fa fa-times-circle text-end"></i></button>
					</div>
					<div className="row">
						<div className="col-12 text-center text-primary">
							<label className="col-form-label">Get your <strong>FREE*</strong> PA, Covid 19 &
								<br />Dengue cover up to RM10,000</label>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col-12 text-center">
							<a className="btn btn-success badge-pill btn-lg px-5" href="https://instapol.my/">Click Here</a>
						</div>
					</div>



				</Modal.Title>
			</Modal.Header>
		</Modal>
	);
}